import {observer} from "mobx-react-lite";
import clubStore from "../../../storage/ClubStore";

const TrainerHome = () => {
    if (!clubStore.club?.is_trainer) return null;
    return (
        <div>
            <h1>Welcome to Trainer Home</h1>
        </div>
    );
}
export default observer(TrainerHome);